var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0"},[(_vm.viewDataIsLoaded)?[_c('app-admin-data-table',{attrs:{"tableData":_vm.viewData,"downloadable":true}})]:_vm._e(),_c('app-snack-bar')],2)}
var staticRenderFns = []

export { render, staticRenderFns }